import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, Kicker, Section } from "@/components/landing/kit";
import { PROCESS } from "@/lib/site-data";

const Process = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start 70%", "end 60%"],
  });
  const lineScale = useTransform(scrollYProgress, [0, 1], [0, 1]);

  return (
    <Section id="process" className="border-b border-[#E5E8F0] bg-white py-24 sm:py-32">
      <Reveal className="mx-auto mb-16 max-w-3xl text-center">
        <Kicker className="mb-5 justify-center">How it works</Kicker>
        <h2 className="text-balance font-heading text-4xl font-black leading-[0.98] tracking-tight text-[#0F1117] sm:text-6xl">
          From zero to a fully-managed store in{" "}
          <span className="text-[#2D5BFF]">60–90 days.</span>
        </h2>
      </Reveal>

      <div ref={ref} className="relative mx-auto max-w-3xl pl-10 sm:pl-16">
        <div className="absolute left-[11px] top-2 h-full w-px bg-[#E5E8F0] sm:left-[19px]" />
        <motion.div
          style={{ scaleY: lineScale }}
          className="absolute left-[11px] top-2 h-full w-px origin-top bg-[#2D5BFF] sm:left-[19px]"
        />

        <div className="space-y-12">
          {PROCESS.map((p, i) => (
            <Reveal key={p.step} delay={i * 0.05} className="relative">
              <span className="absolute -left-10 top-0 flex h-6 w-6 items-center justify-center rounded-full border-2 border-[#2D5BFF] bg-white sm:-left-16 sm:h-10 sm:w-10">
                <span className="h-2 w-2 rounded-full bg-[#2D5BFF] sm:h-3 sm:w-3" />
              </span>
              <div className="flex flex-col gap-2 sm:flex-row sm:items-baseline sm:gap-6">
                <span className="font-heading text-sm font-bold uppercase tracking-[0.3em] text-[#2D5BFF]">
                  Step {p.step}
                </span>
                <div>
                  <h3 className="font-heading text-2xl font-bold tracking-tight text-[#0F1117] sm:text-3xl">
                    {p.title}
                  </h3>
                  <p className="mt-2 max-w-xl text-base leading-relaxed text-[#4B5262]">
                    {p.body}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </Section>
  );
};

export default Process;
